require('./brokerSearchInput.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const debounce = require('lodash/function/debounce');
const classNames = require('classnames');

// @components
const OKSelect = require('components/commons/OKSelect/OKSelect');
const WidgetProductsOption = require('./widgetSearchProducts');
const AllProductsOption = require('./allProductsOption');
const StocksOption = require('./stocksOption');
const FundsOption = require('./fundsOption');

// @helpers
const {
    BROKER_INPUT_SEARCH_WIDGET_PRODUCT,
    BROKER_INPUT_SEARCH_ALLPRODUCTS_MODIFIER,
    BROKER_INPUT_SEARCH_ONLYSTOCKS_MODIFIER,
    BROKER_INPUT_SEARCH_ONLYFUNDS_MODIFIER
} = require('constants/index');

class BrokerSearchInput extends React.Component {

    constructor(props) {
        super(props);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleSearch =  debounce(this.handleSearch.bind(this), 500);
        this.buildResultsMenuScrollTop = this.buildResultsMenuScrollTop.bind(this);
    }

    componentWillMount() {
        if (this.props.resetWhenMounting)
        this.props.onReset();
    }

    /**
     * Duplicated from react-select defaultMenuRenderer.js to build
     * the menu with scroll starting at the very top
     * @param {Object} props
     */
    buildResultsMenuScrollTop(props) {
        let Option = props.optionComponent;

        return props.options.map((option, i) => {
            let isSelected = props.valueArray && props.valueArray.indexOf(option) > -1;
            let isFocused = false;
            let optionClass = classNames(props.optionClassName, {
                'Select-option': true,
                'is-selected': isSelected,
                'is-focused': isFocused,
                'is-disabled': option.disabled,
            });

            return (
                <Option
                    className={optionClass}
                    instancePrefix={props.instancePrefix}
                    isDisabled={option.disabled}
                    isFocused={isFocused}
                    isSelected={isSelected}
                    key={`option-${i}-${option[props.valueKey]}`}
                    onFocus={props.onFocus}
                    onSelect={props.onSelect}
                    option={option}
                    optionIndex={i}
                    ref={ref => { props.onOptionRef(ref, isFocused); }}
                >
                    {props.optionRenderer(option, i)}
                </Option>
            );
        });
    }

    handleBlur(ev) {
        ev.preventDefault();
        ev.stopPropagation();
    }

    //Due that pageSize and plansToReturn are not required
    //and can be managed as default pageSize = 5 and plansToReturn = []
    //We need to check if parent component is sending values on this properties
    //to overwrite them
    handleSearch(inputValue = '') {
        const { 
            resetSelectedValuesOnInput,
            onResetSelectedValues
        } = this.props;
        const product = inputValue.toLowerCase();

        if(resetSelectedValuesOnInput){
            onResetSelectedValues();
        }

        if (product.length > 2) {
            //First conditional case when parent component is sending both properties.
            //Second conditional case when parent component is sending only plansToReturn propertie.
            //Third conditional case when parent component is sending only pageSize propertie.
            //Case else default without parameter (for this case pageSize = 5 and plansToReturn = [])
            if (this.props.pageSize && this.props.plansToReturn) {
                this.props.onSearch(product, this.props.pageSize, this.props.plansToReturn);
            }
            else if (this.props.plansToReturn) {
                this.props.onSearch(this.props.plansToReturn);
            }
            else if (this.props.pageSize ) {
                this.props.onSearch(product, this.props.pageSize);
            } else {
                this.props.onSearch(product);
            }
        }
    }

    render() {
        const {
            fullOpacity,
            inputRenderer,
            results,
            selectedValue,
            isLoading,
            onSelection,
            noResultsText,
            placeholder,
            modifier,
            errorState,
            errorMessage,
            backspaceRemoves,
            startResultsScrollAtTop
        } = this.props;
        const resultsArray = results.toJS();
        let optionComponent;
        let menuRenderer;

        if (startResultsScrollAtTop) {
            menuRenderer = this.buildResultsMenuScrollTop;
        }

        switch (modifier) {
            case BROKER_INPUT_SEARCH_WIDGET_PRODUCT:
                optionComponent = WidgetProductsOption;
                break;
            case BROKER_INPUT_SEARCH_ONLYSTOCKS_MODIFIER:
                optionComponent = StocksOption;
                break;
            case BROKER_INPUT_SEARCH_ONLYFUNDS_MODIFIER:
                optionComponent = FundsOption;
                break;
            case BROKER_INPUT_SEARCH_ALLPRODUCTS_MODIFIER:
            default:
                optionComponent = AllProductsOption;
                break;
        }

        const brokerSearchClasses = classNames('broker-search-input', {
            'broker-search-input--full-opacity': fullOpacity && !!selectedValue
        });

        return (
            <OKSelect
                inputRenderer={inputRenderer}
                className={brokerSearchClasses}
                placeholder={placeholder}
                onChange={onSelection}
                onSelect={onSelection}
                options={resultsArray}
                optionComponent={optionComponent}
                noResultsText={noResultsText}
                isLoading={isLoading}
                value={selectedValue}
                onBlur={this.handleBlur}
                onInputChange={this.handleSearch}
                onBlurResetsInput={false}
                openOnFocus={false}
                autoBlur={true}
                autosize={false}
                errorState={errorState}
                errorMessage={errorMessage}
                backspaceRemoves={backspaceRemoves}
                menuRenderer={menuRenderer}
            />
        );
    }
}

BrokerSearchInput.propTypes = {
    inputRenderer: PropTypes.func,
    results: PropTypes.object.isRequired,
    selectedValue: PropTypes.any,
    pageSize: PropTypes.number,
    plansToReturn: PropTypes.array,
    isLoading: PropTypes.bool.isRequired,
    onSelection: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    noResultsText: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    onReset: PropTypes.func.isRequired,
    resetSelectedValuesOnInput: PropTypes.bool,
    onResetSelectedValues: PropTypes.func,
    onSetPlansList: PropTypes.func,
    fullOpacity: PropTypes.bool,
    modifier: PropTypes.string,
    errorState: PropTypes.bool,
    errorMessage: PropTypes.string,
    backspaceRemoves: PropTypes.bool,
    startResultsScrollAtTop: PropTypes.bool,
    resetWhenMounting: PropTypes.bool,
};

BrokerSearchInput.defaultValues = {
    errorState: false,
    modifier: BROKER_INPUT_SEARCH_ALLPRODUCTS_MODIFIER,
    backspaceRemoves: true,
    resetWhenMounting: true,
    fullOpacity: false
}

module.exports = BrokerSearchInput;